import { FMSType } from "@swivl-mono/types";
import { Spinner } from "@swivl-mono/ui";
import * as React from "react";

import FMSModel from "../../../Models/FMS/FMS.Model";
import { Member } from "../../../Models/Member/Member.Current";
import { useSwivlNavigate } from "../../../Models/NavBar/useSwivlNavigate";
import "./FMSIntegrationsView.scss";

function FMSAddButton(props: { type: FMSType; image: string; title: string; isAddingFMS: boolean | undefined }) {
  return (
    <div
      className="FMSAddButton"
      onClick={() => {
        if (!props.isAddingFMS) {
          FMSModel.addFMS(props.type);
        }
      }}
    >
      <img src={props.image} />
      <div className="hoverState">{props.isAddingFMS ? <Spinner /> : props.title}</div>
    </div>
  );
}

export default function FMSIntegrationsView() {
  const { isLoading, FMSs, isAddingFMS } = FMSModel.useState();
  const navigate = useSwivlNavigate();

  const navigateToFMS = (id: string) => {
    navigate(`/fms/${id}`);
  };

  React.useEffect(() => {
    if (!FMSs) {
      FMSModel.load(false);
    }
  }, [FMSs]);

  if (isLoading) {
    return (
      <div className="FMSIntegrationsView">
        <Spinner />
      </div>
    );
  }

  return (
    <div className="FMSIntegrationsView">
      <div className="ActiveIntegrations">
        <h2>Add FMS</h2>
        <div className="FMSAddButtons">
          <FMSAddButton
            type={FMSType.SiteLink}
            image="https://swivl-cdn.s3.us-west-1.amazonaws.com/app-sitelink.png"
            title="+ ADD SITELINK"
            isAddingFMS={isAddingFMS}
          />
          <FMSAddButton
            type={FMSType.StorEdge}
            image="https://swivl-cdn.s3.us-west-1.amazonaws.com/app-storEdge.png"
            title="+ ADD STOREDGE"
            isAddingFMS={isAddingFMS}
          />
          <FMSAddButton
            type={FMSType.SSM}
            image="https://swivl-cdn.s3.us-west-1.amazonaws.com/app-ssm.png"
            title="+ ADD SSM"
            isAddingFMS={isAddingFMS}
          />
          <FMSAddButton
            type={FMSType.SSMCloud}
            image="https://swivl-cdn.s3-us-west-1.amazonaws.com/FMSLogos/app-ssm-rest.png"
            title="+ ADD SSM Cloud"
            isAddingFMS={isAddingFMS}
          />
        </div>
        <div className="FMSAddButtons">
          <FMSAddButton
            type={FMSType.Tenant}
            image="https://swivl-cdn.s3.us-west-1.amazonaws.com/app-tenant.png"
            title="+ ADD TENANT"
            isAddingFMS={isAddingFMS}
          />
          <FMSAddButton
            type={FMSType.DoorSwap}
            image="https://swivl-cdn.s3-us-west-1.amazonaws.com/app-doorswap.png"
            title="+ ADD DOORSWAP"
            isAddingFMS={isAddingFMS}
          />
          <FMSAddButton
            type={FMSType.StorageCommander}
            image="https://swivl-cdn.s3.us-west-1.amazonaws.com/app-storage-commander.png"
            title="+ ADD STORAGE COMMANDER"
            isAddingFMS={isAddingFMS}
          />
          <FMSAddButton
            type={FMSType.QuikStor}
            image="https://swivl-cdn.s3.us-west-1.amazonaws.com/app-quikstor.png"
            title="+ ADD QuikStor"
            isAddingFMS={isAddingFMS}
          />
          {Member.isSuperAdmin ? (
            <FMSAddButton
              type={FMSType.Storage360}
              image="https://swivl-cdn.s3-us-west-1.amazonaws.com/app-storage-360.png"
              title="+ ADD Storage360"
              isAddingFMS={isAddingFMS}
            />
          ) : null}
        </div>
        <div className="FMSAddButtons">
          {Member.isSuperAdmin ? (
            <FMSAddButton
              type={FMSType.StorageMart}
              image="https://swivl-cdn.s3.us-west-1.amazonaws.com/app-storEdge.png"
              title="+ ADD STORAGE MART"
              isAddingFMS={isAddingFMS}
            />
          ) : null}
          {Member.isSuperAdmin ? (
            <FMSAddButton
              type={FMSType.Cubby}
              image="https://swivl-cdn.s3.us-west-1.amazonaws.com/app-cubby.png"
              title="+ ADD CUBBY"
              isAddingFMS={isAddingFMS}
            />
          ) : null}
        </div>

        <div className="mt-12">
          <h2>Active Integrations</h2>
        </div>
        <div className="ActiveIntegrationsList">
          {FMSs &&
            FMSs.map((fms, index) => {
              return (
                <div className="ActiveIntegrationsItem" key={fms.id}>
                  <img className="icon" src={`https://swivl-cdn.s3.us-west-1.amazonaws.com/fms-icons/${fms.type}-icon.png`} />
                  <div className="name">{fms.name}</div>
                  <button className="edit" onClick={() => navigateToFMS(fms.id?.toString())}>
                    EDIT
                  </button>
                </div>
              );
            })}
        </div>
      </div>
    </div>
  );
}
